import * as React from "react";
import { Grid } from "@mui/material";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";
import Label from "../../utilities/label";
import Input from "../../utilities/input";
import "./companyDetails.css";
import { genesysDetailsContext } from "../../context";
import {
  removeRSpacefromString,
  removeLSpaceFromString,
  validateClientId,
  validateClientSecret,
} from "../../preDefinedFunctions/inputFieldValidations.js";

// ✅ Default fallback
const INITIAL_COMPANY_DETAILS = {
  OrganizationName: "",
  GenesysRegion: "",
  ClientId: "",
  ClientSecret: "",
};

const GenesysCloudCredentials = () => {
  const context = React.useContext(genesysDetailsContext);

  // ✅ Always ensure safe fallback, even if context is undefined
  const initialDetails =
    (typeof context === "function" ? context() : context) || INITIAL_COMPANY_DETAILS;

  const [genesysDetails, setgenesysDetails] = React.useState(initialDetails);

  const [errorMessages, setErrorMessages] = React.useState({
    OrganizationName: "",
    GenesysRegion: "",
    ClientId: "",
    ClientSecret: "",
  });

  // ✅ Input handler
  const handleInputChange = (e) => {
    const { id, value } = e.target;

    // Update main state
    setgenesysDetails((prev) => ({
      ...prev,
      [id]: value,
    }));

    // Validation & error handling
    setErrorMessages((prev) => {
      if (value.trim() === "") {
        return {
          ...prev,
          [id]: `${id.replace(/([A-Z])/g, " $1")} is required`,
        };
      }

      // --- Organization Name ---
      if (id === "OrganizationName") {
        const leftTrim = removeLSpaceFromString(value);
        const rightTrim = removeRSpacefromString(leftTrim.value);
        setgenesysDetails((prev) => ({
          ...prev,
          [id]: rightTrim.value,
        }));
      }

      // --- Genesys Region ---
      if (id === "GenesysRegion") {
        const leftTrim = removeLSpaceFromString(value);
        const rightTrim = removeRSpacefromString(leftTrim.value);
        setgenesysDetails((prev) => ({
          ...prev,
          [id]: rightTrim.value,
        }));
      }

      // --- Client ID Validation ---
      if (id === "ClientId") {
        const leftTrim = removeLSpaceFromString(value);
        const rightTrim = removeRSpacefromString(leftTrim.value);

        setgenesysDetails((prev) => ({
          ...prev,
          [id]: rightTrim.value,
        }));

        const result = validateClientId(rightTrim.value);
        return {
          ...prev,
          [id]: !result.isValid
            ? result.message || "Please enter a valid Client Id"
            : "",
        };
      }

      // --- Client Secret Validation ---
if (id === "ClientSecret") {
  const LefttrimmedResult = removeLSpaceFromString(value);
  const trimmedResult = removeRSpacefromString(LefttrimmedResult.value);
 
  setgenesysDetails((prev) => ({
    ...prev,
    [id]: trimmedResult.value,
  }));
 
  const result = validateClientSecret(trimmedResult.value);
 
  return {
    ...prev,
    [id]: !result.isValid
      ? result.message || "Please enter a valid Client Secret"
      : "",
  };
}


      // Default no error
      return {
        ...prev,
        [id]: "",
      };
    });
  };

  // ✅ Sync updates to context (non-breaking)
  React.useEffect(() => {
    if (context && typeof context === "object") {
      context.organizationName = genesysDetails.OrganizationName;
      context.genesysRegion = genesysDetails.GenesysRegion;
      context.clientId = genesysDetails.ClientId;
      context.clientSecret = genesysDetails.ClientSecret;
    }
  }, [
    genesysDetails.OrganizationName,
    genesysDetails.GenesysRegion,
    genesysDetails.ClientId,
    genesysDetails.ClientSecret,
  ]);

  // ✅ Render
  return (
    <MainTheme>
      <Title title="Genesys Cloud Credentials" />

      <div className="organization-details-section">
        <Grid container spacing={2} className="conatiner-section" />

        {/* Organization Name Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Organization Name" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
              type="text"
              required={true}
              id="OrganizationName"
              label="Organization Name"
              value={genesysDetails.OrganizationName}
              handleOnChange={handleInputChange}
              placeholder="Enter your Organization name"
              errorMessage={errorMessages.OrganizationName}
            />
          </Grid>
        </Grid>

        {/* Genesys Region Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Genesys Region" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
              type="text"
              required={true}
              id="GenesysRegion"
              label="Genesys Region"
              value={genesysDetails.GenesysRegion}
              handleOnChange={handleInputChange}
              placeholder="Enter Genesys region"
              errorMessage={errorMessages.GenesysRegion}
            />
          </Grid>
        </Grid>

        {/* Client Id Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Client Id" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
              type="text"
              required={true}
              id="ClientId"
              label="Client Id"
              value={genesysDetails.ClientId}
              handleOnChange={handleInputChange}
              placeholder="Enter Client Id"
              errorMessage={errorMessages.ClientId}
            />
          </Grid>
        </Grid>

        {/* Client Secret Field */}
        <Grid container className="company-name-container">
          <Grid item xs={12} className="organization-titles">
            <Label title="Client Secret" />
          </Grid>
          <Grid item md={9} xs={12} className="input-company-div">
            <Input
              type="text"
              required={true}
              id="ClientSecret"
              label="Client Secret"
              value={genesysDetails.ClientSecret}
              handleOnChange={handleInputChange}
              placeholder="Enter Client Secret"
              errorMessage={errorMessages.ClientSecret}
            />
          </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default GenesysCloudCredentials;
